import React from 'react'
import { Text, Spacer, useMediaQuery } from '@geist-ui/react'

export default function EnrollmentHeader({ title, description }) {
  const isMD = useMediaQuery('md', { match: 'up' })

  return (
    <>
      <Text
        h3
        font="32px"
        style={{ lineHeight: '34px', textAlign: isMD ? 'left' : 'center' }}
      >
        {title || 'Enroll Today!'}
      </Text>
      {description && (
        <Text
          font="18px"
          p
          style={{ lineHeight: '28px', textAlign: isMD ? 'left' : 'center' }}
        >
          {description}
        </Text>
      )}
      <Spacer h={1} />
    </>
  )
}

